import { defineComponent as _defineComponent } from 'vue'
import Offer from '@/models/Offer';
import OfferDetailsShort from '@/components/calculator/printout/OfferDetailsShort.vue';
import { SimulationDemand } from '@/models/Demand';


export default /*#__PURE__*/_defineComponent({
  __name: 'OffersPreview',
  props: {
    selectedOffers: { default: () => [] },
    userInput: { default: () => new SimulationDemand() }
  },
  setup(__props: any) {

const props = __props as { selectedOffers: Offer[], userInput: SimulationDemand }



return { __sfc: true,props, OfferDetailsShort }
}

})